import { Link } from '@chakra-ui/react';

const siteNavLinks = [
    {
        label: 'Info Sec Policy',
        href: 'https://www.detectorinspector.com.au/information-security-policy/',
    },
    {
        label: 'Privacy Policy',
        href: 'https://www.detectorinspector.com.au/privacy-policy/',
    },
    {
        label: 'Insurance Policy',
        href: 'https://www.detectorinspector.com.au/insurance-policy/',
    },
    {
        label: 'Terms of Service',
        href: 'https://www.detectorinspector.com.au/terms-conditions/',
    },
    {
        label: 'EULA',
        href: 'https://help.detectorinspector.com.au/hc/en-au/articles/12276630164623',
    },
];

export function SiteNavLinks() {
    return siteNavLinks.map((link) => (
        <Link
            key={link.href}
            href={link.href}
            isExternal
            _hover={{ color: 'primary.500' }}
        >
            {link.label}
        </Link>
    ));
}
